import axios from 'axios'
import moment from 'moment'
import endpoints from '../configuration/endpoints'

export const REQUEST_SHIP_AVAILABLE_DATES = 'REQUEST_SHIP_AVAILABLE_DATES'
export const RECEIVE_SHIP_AVAILABLE_DATES = 'RECEIVE_SHIP_AVAILABLE_DATES'
export const SHIP_AVAILABLE_DATES_ERROR = 'SHIP_AVAILABLE_DATES_ERROR'

const requestShipAvailableDatesArray = () => ({
  type: REQUEST_SHIP_AVAILABLE_DATES
})

const receiveShipAvailableDates = availableDates => ({
  type: RECEIVE_SHIP_AVAILABLE_DATES,
  payload: availableDates
})

const receiveShipAvailableDatesError = () => ({
  type: SHIP_AVAILABLE_DATES_ERROR
})

export const requestShipAvailableDates = () => (dispatch, getState) => {
  const { ships } = getState()

  const ship_code = ships && ships.shipDetails && ships.shipDetails.ship_code
  const brand_code = ships && ships.shipDetails && ships.shipDetails.brand_code

  const params = `${moment().format(
    'YYYY-MM-DD'
  )}?brand=${brand_code}&ship=${ship_code}`
  dispatch(requestShipAvailableDatesArray())

  return axios
    .get(`${endpoints.calendar}${params}`)
    .then(res => {
      dispatch(receiveShipAvailableDates(res && res.data && res.data.data))
    })
    .catch(err => {
      console.log(err)
      dispatch(receiveShipAvailableDatesError())
    })
}
